var map = {
	"./Delete-click.webp": "./src/assets/imgs/cloudSpace/Delete-click.webp",
	"./Delete.webp": "./src/assets/imgs/cloudSpace/Delete.webp",
	"./Download.webp": "./src/assets/imgs/cloudSpace/Download.webp",
	"./Import-click.webp": "./src/assets/imgs/cloudSpace/Import-click.webp",
	"./Import-list.webp": "./src/assets/imgs/cloudSpace/Import-list.webp",
	"./Import.webp": "./src/assets/imgs/cloudSpace/Import.webp",
	"./Import_hover.webp": "./src/assets/imgs/cloudSpace/Import_hover.webp",
	"./Select All.webp": "./src/assets/imgs/cloudSpace/Select All.webp",
	"./Select All_select.webp": "./src/assets/imgs/cloudSpace/Select All_select.webp",
	"./cancel.webp": "./src/assets/imgs/cloudSpace/cancel.webp",
	"./cancel_hover.webp": "./src/assets/imgs/cloudSpace/cancel_hover.webp",
	"./default-image.webp": "./src/assets/imgs/cloudSpace/default-image.webp",
	"./download-click-small.webp": "./src/assets/imgs/cloudSpace/download-click-small.webp",
	"./download-click.webp": "./src/assets/imgs/cloudSpace/download-click.webp",
	"./grid-hover.webp": "./src/assets/imgs/cloudSpace/grid-hover.webp",
	"./grid.webp": "./src/assets/imgs/cloudSpace/grid.webp",
	"./hms_arrow.webp": "./src/assets/imgs/cloudSpace/hms_arrow.webp",
	"./information.webp": "./src/assets/imgs/cloudSpace/information.webp",
	"./list-hover.webp": "./src/assets/imgs/cloudSpace/list-hover.webp",
	"./list.webp": "./src/assets/imgs/cloudSpace/list.webp",
	"./loading_32x32.webp": "./src/assets/imgs/cloudSpace/loading_32x32.webp",
	"./more.webp": "./src/assets/imgs/cloudSpace/more.webp",
	"./noContent.webp": "./src/assets/imgs/cloudSpace/noContent.webp",
	"./notification_slicing_complete.webp": "./src/assets/imgs/cloudSpace/notification_slicing_complete.webp",
	"./pic.webp": "./src/assets/imgs/cloudSpace/pic.webp",
	"./rotate-cw.webp": "./src/assets/imgs/cloudSpace/rotate-cw.webp",
	"./storageSpace.webp": "./src/assets/imgs/cloudSpace/storageSpace.webp",
	"./uploadBtn.webp": "./src/assets/imgs/cloudSpace/uploadBtn.webp",
	"./view.webp": "./src/assets/imgs/cloudSpace/view.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/imgs/cloudSpace sync recursive ^\\.\\/.*\\.webp$";